// @flow

export const SAVE_COUNTRIES: 'save/countries' = 'save/countries';
export const SAVE_STATES_BY_COUNTRY: 'save/states/by-country' = 'save/states/by-country';

export type Action =
  | {
    type: typeof SAVE_COUNTRIES,
    countries: {},
  }
  | {
    type: typeof SAVE_STATES_BY_COUNTRY,
    states: {}
  }
  ;
